
import { Spain } from "../_Translate/Spain";
import { English } from "../_Translate/English";

export const HAS__LOGIN_RESOURCE_API = false;

const TRANSLATE = { es: Spain, en: English };

export const onLoginContent = (lang = "es") => (TRANSLATE[lang] ?? Spain).LOGIN;

export const LOGIN_CONTENT = onLoginContent();
